// src/components/TopBar.js
import React, { useState } from 'react';

function TopBar({ fullname = '', onLogout }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleNameClick = () => {
    setIsOpen(!isOpen);
  };

  const handleAccountClick = () => {
    // If you want to navigate somewhere:
    window.location.href = '/account';
  };

  const handleLogoutClick = () => {
    onLogout(); // calls handleLogout in App.js
  };

  return (
    <div
      className="w-full bg-[#0EA5E9] text-white flex justify-end items-center px-4"
      style={{ height: '75px' }}
    >
      <div className="relative inline-block">
        <div className="cursor-pointer p-2" onClick={handleNameClick}>
          {`Hello, ${fullname}!`}
        </div>

        {isOpen && (
          <div className="absolute right-0 mt-2 w-32 bg-white text-black rounded shadow-lg">
            <div
              className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
              onClick={handleAccountClick}
            >
              Account
            </div>
            <div
              className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
              onClick={handleLogoutClick}
            >
              Logout
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default TopBar;